import styled, { css } from 'styled-components'

interface IWrapperProps {
  actionBackground: boolean
  actionBackgroundColor: string
  actionTitleColor: string
  padding: string
  background: string
  boxShadow: boolean
}

export const Wrapper = styled.div<IWrapperProps>`
  width: 100%;
  border-radius: 16px;
  text-align: center;
  padding: ${(props) => props.padding};
  background-color: ${(props) => props.background};
  ${(props) =>
    props.boxShadow &&
    css`
      border: 1px solid #f0f0f0;
      box-shadow: 0px 4px 8px 0px #00000014;
    `}
  button {
    ${(props) =>
      props.actionBackground &&
      css`
        background-color: ${props.actionBackgroundColor} !important;
      `}
    box-shadow: none;
    border: none;
    border-radius: 8px;
    padding: 0 16px;
    margin-top: 12px;
    font-weight: 700;
    font-size: 16px;
    color: ${(props) => props.actionTitleColor} !important;
    svg {
      margin-right: 5px;
    }
    &:hover {
      opacity: 0.7;
    }
  }
  button:disabled {
    opacity: 0.48;
  }
`

interface IIconWrapperProps {
  iconSize: string
  iconBackground: string
  iconColor: string
  iconBadgeBackground: string
}

export const IconWrapper = styled.div<IIconWrapperProps>`
  ${(props) =>
    props.iconSize == 'large' &&
    css`
      width: 88px;
      height: 88px;
      > svg {
        padding: 10px;
        height: 25px;
      }
      > span > svg {
        width: 16px;
        height: 16px;
        padding: 4px;
        margin-top: -32px;
        margin-left: -18px;
      }
    `}
  ${(props) =>
    props.iconSize == 'normal' &&
    css`
      width: 72px;
      height: 72px;
      > svg {
        padding: 10px;
        height: 20px;
      }
      > span > svg {
        width: 16px;
        height: 16px;
        padding: 4px;
        margin-top: -36px;
        margin-left: -10px;
      }
    `}
  ${(props) =>
    props.iconSize == 'small' &&
    css`
      width: 56px;
      height: 56px;
      > svg {
        padding: 9px;
        height: 15px;
      }
      > span > svg {
        padding: 4px;
        height: 10px;
        width: 10px;
        margin-top: -29px;
        margin-left: -8px;
      }
    `}
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${(props) => props.iconBackground};
  margin: 0 auto;
  position: relative;
  > svg {
    background-color: white;
    border-radius: 8px;
    color: ${(props) => props.iconColor};
  }
  > span > svg {
    position: absolute;
    border-radius: 50%;
    color: white;
    background: ${(props) => props.iconBadgeBackground};
  }
`

export const Title = styled.div<{
  color: string
  fontWeight: string
  fontSize: string
}>`
  max-width: 500px;
  margin: 0 auto;
  color: ${(props) => props.color};
  padding: 16px 0 4px;
  font-size: ${(props) => props.fontSize};
  font-weight: ${(props) => props.fontWeight};
`

export const Description = styled.div<{ color: string; fontSize: string }>`
  max-width: 500px;
  margin: 0 auto;
  color: ${(props) => props.color};
  padding: 4px 0;
  font-size: ${(props) => props.fontSize};
`

export const Actions = styled.div<{ actionTitleColor: string }>`
  display: flex;
  justify-content: center;
  gap: 16px;

  button {
    box-shadow: none;
    border: none;
    border-radius: 8px;
    padding: 0 8px;
    font-weight: 700;
    color: ${(props) => props.actionTitleColor} !important;
    svg {
      margin-right: 5px;
    }
    &:hover {
      opacity: 0.7;
    }
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`
